module.exports = __webpack_public_path__ + "static/a14-75cdf76e626661e8989c7c6ce29ffc7b.jpg";